export default __webpack_public_path__ + "static/media/leftArrow.b26dbb9d.svg";